import {
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonNote,
} from '@ionic/react';
import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  settingsOutline,
  cardOutline,
  locationOutline,
  receiptOutline,
  pricetagOutline,
  restaurantOutline,
  logOutOutline,
  alertOutline,
  alertCircleOutline,
  heartCircleOutline,
  bluetoothOutline,
} from 'ionicons/icons';
import AuthActions, { AuthSelectors } from 'redux/AuthRedux';
import { AppSelectors } from 'redux/AppRedux';
import { setHistory } from 'utils/history';
import './Menu.css';
import { PaySelectors } from 'redux/PayRedux';

const Menu = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const invite = useSelector(AppSelectors.selectInvite);
  const user = useSelector(AuthSelectors.selectUser);
  const ticket = useSelector(PaySelectors.selectTicket);
  const logout = () => dispatch(AuthActions.logout());

  const appPages = [
    {
      title: 'Locations',
      url: '/locations',
      icon: locationOutline,
    },
    {
      title: 'Payment',
      url: '/payment-methods',
      icon: cardOutline,
    },
    {
      title: 'Receipts',
      url: '/receipts',
      icon: receiptOutline,
    },
    {
      title: 'Promotions',
      url: '/promotions',
      icon: pricetagOutline,
    },
    {
      title: 'Loyalty',
      url: '/loyalty',
      icon: heartCircleOutline,
    },
    /* 
    {
      title: 'Bluetooth',
      url: '/bluetooth-test',
      icon: bluetoothOutline,
    },
    */
    {
      title: 'Account Settings',
      url: '/account-settings',
      icon: settingsOutline,
    },
    {
      title: 'About',
      url: '/about',
      icon: alertCircleOutline,
    },
  ];

  if (process.env.REACT_APP_SHOW_TEST) {
    appPages.push({
      title: 'GeoLocation Test',
      url: '/location-test',
      icon: locationOutline,
    });
  }

  if (ticket) {
    appPages.splice(1, 0, {
      title: 'Current Tab',
      url: `/locations/${ticket.venueId}/tab`,
      icon: restaurantOutline,
    });
  }

  if (invite) {
    appPages.splice(0, 1, {
      title: (
        <span>
          My Tab <IonIcon color="warning" icon={alertOutline} />
        </span>
      ),
      url: `/invite/${invite.venueId}/${invite.ticketId}`,
      icon: locationOutline,
    });
  }

  useEffect(() => {
    setHistory(history);
  }, []);

  return (
    <IonMenu contentId="main" type="overlay">
      <IonContent>
        <IonList className="inbox-list">
          <IonListHeader>
            {user.firstName} {user.lastName}
          </IonListHeader>
          <IonNote>{user.email}</IonNote>
          {appPages.map((appPage, index) => {
            return (
              <IonMenuToggle key={index} autoHide={false}>
                <IonItem
                  className={location.pathname === appPage.url && 'selected'}
                  routerLink={appPage.url}
                  routerDirection="none"
                  lines="none"
                  detail={false}
                >
                  <IonIcon slot="start" icon={appPage.icon} />
                  <IonLabel>{appPage.title}</IonLabel>
                </IonItem>
              </IonMenuToggle>
            );
          })}
          <IonMenuToggle autoHide={false}>
            <IonItem onClick={logout} lines="none" detail={false}>
              <IonIcon slot="start" icon={logOutOutline} />
              <IonLabel>Logout</IonLabel>
            </IonItem>
          </IonMenuToggle>
        </IonList>
      </IonContent>
    </IonMenu>
  );
};

export default Menu;
